export default __webpack_public_path__ + "static/media/logoDarkBackground.d3f1a773.svg";